import { render, staticRenderFns } from "./ChartRing.vue?vue&type=template&id=10875d54&scoped=true"
import script from "./ChartRing.vue?vue&type=script&lang=js"
export * from "./ChartRing.vue?vue&type=script&lang=js"
import style0 from "./ChartRing.vue?vue&type=style&index=0&id=10875d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10875d54",
  null
  
)

export default component.exports